import { render, staticRenderFns } from "./PendingApprovals.vue?vue&type=template&id=d8f91440&scoped=true&"
import script from "./PendingApprovals.vue?vue&type=script&lang=js&"
export * from "./PendingApprovals.vue?vue&type=script&lang=js&"
import style0 from "./PendingApprovals.vue?vue&type=style&index=0&id=d8f91440&lang=scss&scoped=true&"
import style1 from "./PendingApprovals.vue?vue&type=style&index=1&id=d8f91440&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f91440",
  null
  
)

export default component.exports